import Resizer from 'react-image-file-resizer'

const resizeFile = async (
  file,
  maxWidth = 500,
  maxHeight = 500,
  format = 'WEBP',
  quality = 90,
  type = 'file'
) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      format,
      quality,
      0,
      (uri) => {
        resolve(uri)
      },
      type
    )
  })

export default resizeFile
